/**
 * Public-facing legal pages hosted on the marketing site. These are external
 * links (opened in a new tab) — not internal app routes.
 */
export const TERMS_OF_SERVICE_URL = 'https://www.opsium.io/legal/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://www.opsium.io/legal/privacy-policy';
